/**
 * 发行平台-藏品权益领取
 * nftNo
 * targetId
 * targetType 1:藏品 2:欧皇徽章
 */
import Styles from "./index.module.scss";
import NFTHeader from "@/components/NFTHeader";
import React, {useEffect, useState} from "react";
import {Button, Grid, Toast} from "antd-mobile";
import {hideLoading, showLoading} from "@/components/loading";
import Service from "../service";
import {getUrlAllParams, objectToQueryParams} from "@/utils/publicFun";
import {useLocation, useNavigate} from "react-router";
import _ from "lodash"
import NFTModal from "@/components/NFTModal";
import CodeModal from "@/view/nftPad/benefitGet/CodeModal";
import ConfirmToPointModal from "@/view/nftPad/paySuccess/components/confirmToPointModal";

export default () => {
  const navigate = useNavigate()
  const { search } = useLocation()
  const params = getUrlAllParams(search.slice(1));
  const [data, setData] = useState([])
  const [btnLoading, setBtnLoading] = useState(false)
  const [btnLoading2, setBtnLoading2] = useState(false)
  const [checkInfoMap, setCheckInfoMap] = useState({}) // 权益领取情况
  //  expired: false, // 是否在有效期：true有效，false无效
  //  claimed: true, // 是否已领取：true已领取，false未领取
  //  isCurrentUser: false // 是否当前用户领取：true是，false否
  const [checkData, setCheckData] = useState({}) //canConvert 0:可转化，1:不可转化(已领取或已过期)，2:已转化

  const getData = async (loading = false) => {
    try {
      if (loading) showLoading();
      const queryParams = {
        targetType: +params?.targetType, // 1-针对藏品, 2-针对欧皇徽章
        targetId: params?.targetId,
        nftNo: params?.targetType == 1 ? params?.nftNo : null
      }
      const [benefitInfo, benefitCheckInfo] = await Promise.all([
        Service.getBenefitInfo(queryParams),
        Service.getBenefitCheckInfo(queryParams)
      ])
      if (loading) hideLoading();
      if (benefitInfo.code !== '000000') throw benefitInfo.msg
      if (benefitCheckInfo.code !== '000000') throw benefitCheckInfo.msg
      setData(benefitInfo?.data)
      setCheckData(benefitCheckInfo?.data)
      if(benefitCheckInfo?.data.list?.length > 0) {
        const result = _.keyBy(benefitCheckInfo.data.list, 'id')
        setCheckInfoMap(result)
      }
    } catch (error) {
      hideLoading();
      Toast.show(error);

    }
  }

  useEffect(() => {
    getData(true)
  }, [])

  const toRightsOrder = async (item, expired) => {
    if(!expired) {
      return Toast.show('权益在不在有效期内')
    }
    const queryParams = objectToQueryParams({
      targetType: params?.targetType, // 1-针对藏品, 2-针对欧皇徽章
      targetId: params?.targetId,
      nftNo: params?.nftNo,
      reqId: item?.id,
      benefitName: item?.benefitName,
      imgUrl: item?.imgUrl,
      quantity: item?.quantity,
    })
    navigate(`/nftPad/rightsOrder?${queryParams}`)
  }

  const toOrderDetail = (item) => {
    navigate(`/nftPad/orderDetail?reqId=${item.id}&nftNo=${params?.nftNo}`)
  }
  const toCarbonRightsGet = () => {
    const url = `/culturalExchange_taijigreencarbon/collectionRecord`
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.push("CustomWeb", { uri: `${window.location.origin}${url}` });
    } else {
      navigate(url);
    }
  }

  const getPointRights = async (id, expired, benefitType = null) => {
    if(!expired) {
      return Toast.show('权益在不在有效期内')
    }
    try {
      if(benefitType === 6) {
        setBtnLoading2(true)
      } else {
        setBtnLoading(true)
      }
      const res = await Service.getBenefit({
        targetType: +params?.targetType,
        targetId: params?.targetId,
        nftNo: params?.nftNo,
        reqId: id,
      })
      if (res.code !== '000000') throw res.msg
      Toast.show('领取成功')
      getData()
    } catch (e) {
      Toast.show(e)
      console.log(e)
    }
    setBtnLoading(false)
    setBtnLoading2(false)
  }

  const openCodeModal = (item) => {
    const codeList = item?.redeemCode
    const ModalInstance = NFTModal.show({
      content: <CodeModal onClose={() => ModalInstance?.close()} codeList={codeList} />,
    })
  }

  const btnRender = (item) => {
    const checkInfo = checkInfoMap[item.id]
    if(checkInfo?.claimed && (!checkInfo?.isCurrentUser && +params?.targetType !== 2)) {
      return null
    }
    if(params?.targetType == 1 && checkData?.canConvert === 2) {
      return <Button block shape='rounded' className={Styles.btn} disabled>已转化为{checkData?.convertType === 1 ? '宝石' : '积分'}</Button>
    }
    if(item.benefitType === 1) {
      return <Button block shape='rounded' onClick={toCarbonRightsGet} className={Styles.btn}>请至绿碳申请中操作</Button>
    } else if(item.benefitType === 2) {
      if(checkInfo?.claimed) {
        return <Button block shape='rounded' className={Styles.btn} onClick={() => toOrderDetail(item)}>查看详情</Button>
      }
      return <Button block shape='rounded' className={Styles.btn} style={{ filter: checkInfo?.expired ? '' : 'grayscale(1)'}} onClick={() => toRightsOrder(item, checkInfo?.expired)}>领取权益</Button>
    } else if(item.benefitType === 3) {
      if(checkInfo?.claimed) {
        return <Button block shape='rounded' className={Styles.btn} disabled>已领取</Button>
      }
      return <Button
        loading={btnLoading}
        block
        shape='rounded'
        onClick={() => getPointRights(item.id, checkInfo?.expired)}
        className={Styles.btn}
        style={{ filter: checkInfo?.expired ? '' : 'grayscale(1)'}}
      >
        领取权益
      </Button>
    } else if(item.benefitType === 6) {
      if(checkInfo?.claimed) {
        return <Button block shape='rounded' className={Styles.btn} onClick={() => openCodeModal(checkInfo)}>查看详情</Button>
      }
      return <Button
        loading={btnLoading2}
        block
        shape='rounded'
        className={Styles.btn}
        style={{ filter: checkInfo?.expired ? '' : 'grayscale(1)'}}
        onClick={() => getPointRights(item.id, checkInfo?.expired, 6)}
      >领取权益</Button>
    }
  }

  const handleConvert = () => {
    const ModalInstance = NFTModal.show({
      content: <ConfirmToPointModal
        onClose={() => ModalInstance?.close()}
        selectNftNo={[params?.nftNo]}
        totalCount={checkData?.convertCount || 0}
        convertType={checkData?.convertType}
        successCallBack={() => {
          ModalInstance?.close()
          getData()
        }}
      />,
    });
  }

  const rightNodeRender = () => {
    if (params?.targetType == 1 && checkData?.canConvert === 0) {
      return <div className={Styles.rightNode} onClick={handleConvert}>转化</div>
    }
    return null
  }
  return (
    <div className={Styles.getGuardsBenefit}>
      <NFTHeader
        midText={+params?.targetType === 2 ? '欧皇徽章权益领取' : "藏品权益领取"}
        bgColor="#FFFFFF"
        rightNode={rightNodeRender}
      />
      <div className={Styles.container}>
        <Grid columns={2} gap={[32, 64]}>
          {data?.length > 0 && data.map((item, index) => {
            return (
              <Grid.Item key={index}>
                <div className={Styles.benefitItem} key={index}>
                  <div className={Styles.imgCard}>
                    <img className={Styles.imgBox} src={item.imgUrl} alt=""/>
                    {checkInfoMap?.[item.id]?.claimed && <div className={Styles.claimedOverlay}>已领取</div>}
                  </div>
                  <div className={Styles.name}>{item?.benefitType === 3 && item?.quantity}{item.benefitName}</div>
                  {btnRender(item)}
                </div>
              </Grid.Item>
            )
          })}
        </Grid>
      </div>
    </div>
  )
}